<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">车辆退款</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="refundForm" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem v-if="vehicle" label="车辆状态:" prop="status">
          <span>{{vehicle ? (vehicle.status === 1 ? '已激活' : (vehicle.status === 2 ? '已报停' : '未激活')) : '--'}}</span>
        </FormItem>
        <FormItem v-if="vehicle" label="退款车辆:" prop="cipherNumber">
          <Input v-model="vehicle.cipherNumber" size="small" disabled />
        </FormItem>
        <FormItem v-if="vehicle" label="当前有效期:" prop="expireTime">
          <Input v-model="vehicle.expireTime" size="small" disabled />
        </FormItem>
        <FormItem label="原过期时间:" v-if="vehicle && vehicle.status === 2" prop="suspendDate">
          <Input v-model="vehicle.suspendDate" size="small" disabled />
        </FormItem>
        <FormItem label="缴费金额:">
          <Input v-model="paidTotal" size="small" disabled />
        </FormItem>
        <FormItem label="赠送天数:">
          <Input v-model="freeDays" size="small" disabled />
        </FormItem>
        <FormItem label="退款用户:" prop="userId">
          <Select
            v-model="formFields.userId"
            clearable
            filterable
            placeholder="请选择退款用户..."
            size="small"
          >
            <Option
              v-for="member in members"
              :key="member.id"
              :value="member.userId"
              :label="member.memberName + (member.ownerFlag ? ' (车主)' : '')"
            />
          </Select>
        </FormItem>
        <FormItem v-if="vehicle && vehicle.expireTime" label="过期时间:" prop="targetExpireDate">
          <DatePicker
            v-model="formFields.targetExpireDate"
            type="date"
            format="yyyy-MM-dd"
            :options="dateOptions"
            :disabled="vehicle.status === 2"
            placeholder="请输入车辆过期时间..."
            style="width: 100%"
            size="small"
            @on-change="onExpireTimeChange"
          />
        </FormItem>
        <FormItem label="退款金额:">
          <Input v-model="refundAmount" size="small" disabled />
        </FormItem>
        <FormItem label="退款指令:">
          <RadioGroup v-model="formFields.terminate" @on-change="onModeChange">
            <Radio :label="1" :true-value="1">
              禁止出入
            </Radio>
            <Radio :label="0" :true-value="0">
              自由出入(过期前)
            </Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div style="font-size: 12px; text-align: right; color: #69c" v-if="vehicle && vehicle.status === 2">
        <Icon type="md-information-circle" /> 车辆报停时，只能退自报停日期之后的剩余时间。
      </div>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus || paidTotal === 0"
        size="small"
        icon="ios-undo"
        :loading="submit"
        @click="refund"
      >
        退款
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import { dateFormat, isAfter } from '@/utils/util'
export default {
  name: 'VehicleRefund',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 500
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      members: [],
      loadingStatus: false,
      refundAmount: 0,
      paidTotal: 0,
      freeDays: 0,
      modal: true,
      submit: false,
      vehicle: undefined,
      checked: false,
      formFields: {
        id: this.id,
        userId: 0,
        targetExpireDate: '',
        terminate: 1
      }
    }
  },
  computed: {
    dateOptions() {
      return {
        disabledDate(date) {
          const disabled = date && (date.valueOf() < Date.now() - 86400000)
          return disabled
        }
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    ruleValidate() {
      return {
        userId: [{ required: true, message: '退款用户不能为空!' }],
        targetExpireDate: [{ required: true, message: '过期时间不能为空' }]
      }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadData()
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    resetForm() {
      this.formFields = { id: 0, userId: 0, targetExpireDate: new Date(), terminate: 1 }
      this.refundAmount = 0
      this.checked = false
      this.freeDays = 0
      this.paidTotal = 0
      this.vehicle = undefined
      // this.$refs.refundForm.resetFields()
    },
    onModeChange(e) {
      this.loadRefundAmount()
    },
    async loadVehicleMembers() {
      this.loadingStatus = true
      request({
        url: this.$config.apiContextPath + '/vehicle/' + this.id + '/relation',
        method: 'get'
      }).then(res => {
        this.members = res.data
        const owner = this.members.find(m => m.ownerFlag === 1)
        if (owner) {
          this.formFields.userId = owner.userId
        }
        this.loadRefundAmount()
        this.loadingStatus = false
      }).catch(err => {
        this.$Notice.error({ title: '车辆用户加载失败:' + err })
        this.loadingStatus = false
      })
    },
    async onExpireTimeChange(date) {
      this.refundAmount = 0
      this.checked = false
      this.formFields.targetExpireDate = ''
      if (date) {
        if (isAfter(date, this.vehicle.expireTime)) {
          this.$Notice.error({ title: '过期时间不能超过车辆当前有效期' })
        } else {
          this.formFields.targetExpireDate = date
          await this.loadRefundAmount()
        }
      }
    },
    loadRefundAmount() {
      if (this.formFields.targetExpireDate) {
        this.submit = true
        request({
          url: this.$config.apiContextPath + '/vehicle/' + this.id + '/action/refund/amount',
          method: 'get',
          params: { id: this.id, date: dateFormat(new Date(this.formFields.targetExpireDate), 'yyyy-MM-dd'), terminate: this.formFields.terminate }
        }).then(res => {
          const data = res.data
          this.refundAmount = data.refund.toFixed(2)
          this.paidTotal = data.total.toFixed(2)
          this.freeDays = data.freeDays
          this.submit = false
          this.checked = true
        }).catch(err => {
          this.$Notice.error({ title: '获取车辆退款金额失败: ' + err })
          this.submit = false
        })
      }
    },
    async loadData() {
      if (this.visible && this.id) {
        this.loadingStatus = true
        this.vehicle = null
        this.members = []
        request({
          url: this.$config.apiContextPath + '/vehicle/' + this.id,
          method: 'get'
        }).then(res => {
          this.vehicle = res.data
          if (this.vehicle.status === 2 && this.vehicle.suspendDate) {
            this.formFields.targetExpireDate = this.vehicle.expireTime
          }
          this.loadVehicleMembers()
        }).catch(err => {
          this.$Notice.error({ title: '车辆信息加载失败:' + err })
          this.loadingStatus = false
        })
      }
    },
    refund() {
      if (this.visible && this.id && this.vehicle) {
        if (this.checked) {
          const _this = this
          this.$Modal.confirm({
            title: '确认退款车辆么？',
            loading: true,
            render: (h, params) => {
              return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, this.vehicle ? this.vehicle.cipherNumber : '')])
            },
            onOk: function() {
              const _that = this
              request({
                url: _this.$config.apiContextPath + '/vehicle/' + _this.id + '/action/refund?userId=' +
                  _this.formFields.userId + '&date=' + dateFormat(new Date(_this.formFields.targetExpireDate), 'yyyy-MM-dd') + '&terminate=' + _this.formFields.terminate,
                method: 'post'
              }).then(res => {
                _this.$Notice.success({ title: '车辆退款成功' })
                _this.closeModal(true)
                this.$Modal.remove()
              }).catch(err => {
                _this.$Notice.error({ title: '车辆退款失败:' + err })
                _that.buttonLoading = false
              })
            }
          })
        } else {
          this.$Notice.error({ title: '车辆退款金额获取失败' })
        }
      }
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

<style lang="less" scoped>

</style>
